// extracted by mini-css-extract-plugin
export const wrapper = "PageHeadline-module--wrapper--3Xtpw";
export const alignLeft = "PageHeadline-module--alignLeft--2x9jJ";
export const text = "PageHeadline-module--text--VbBi1";
export const divider = "PageHeadline-module--divider--3t-a1";